import './index.css'
import cn from 'clsx'

import React, { useCallback, useState } from 'react'
import Collapsible from 'components/ui/collapsible'
import Flex from 'components/ui/flex'
import Heading from 'components/ui/heading'
import Icon from 'components/ui/icon'
type Props = {
  action?: React.ReactNode
  children?: React.ReactNode
  collapsible?: boolean
  description?: React.ReactNode
  disabled?: boolean
  title?: React.ReactNode
  footer?: React.ReactNode
  header?: React.ReactNode
}

const Section = ({
  action,
  children,
  collapsible,
  description,
  disabled,
  title,
  footer,
  header,
}: Props): React.ReactElement<'div'> => {
  const [open, setOpen] = useState<boolean>(false)
  const titleNode: React.ReactNode = <Heading size={500}>{title}</Heading>
  const icon: React.ReactNode = (
    <div
      className={cn('PageContainer-section-icon', {
        'PageContainer-section-icon--open': open,
      })}
    >
      <Icon type="arrow-down" />
    </div>
  )
  const content: React.ReactNode = (
    <div className="PageContainer-section-content">{children}</div>
  )
  const stopPropagation = useCallback(
    (event: React.SyntheticEvent<any>) => event.stopPropagation(),
    [],
  )
  const toggleOpen = useCallback(() => {
    setOpen(open => !open)
  }, [])
  return (
    <div
      className={cn('PageContainer-section', {
        'PageContainer-section--disabled': disabled,
      })}
    >
      {(title || header) && (
        <div
          className={cn('PageContainer-section-header', {
            'PageContainer-section-header--clickable': collapsible && !disabled,
          })}
          onClick={collapsible && !disabled ? toggleOpen : undefined}
        >
          {header}
          {title ? (
            <div className="PageContainer-section-title">
              {collapsible ? (
                <Flex spacing="small">
                  {titleNode}
                  {icon}
                </Flex>
              ) : (
                titleNode
              )}
              {description && (
                <div className="PageContainer-section-description">
                  {description}
                </div>
              )}
            </div>
          ) : null}
          {action && (
            <div
              className="PageContainer-section-action"
              onClick={stopPropagation}
            >
              {action}
            </div>
          )}
        </div>
      )}
      {collapsible ? <Collapsible open={open}>{content}</Collapsible> : content}
    </div>
  )
}

export default Section
